import { View, ViewModel } from "binder"
import { MainWindowViewModel } from "../mainWindow-viewModel";

export class MainWindowPhoneView extends View<MainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-EAA4E7F8-3BDA-4005-B343-0B8CC658D534"
    }
    loadHtml(): string {
        let element = require('./mainWindowPhone.html').default;
        let style = require('./mainWindowPhone.less');
        return element;
    }
    constructor() {
       super();
    }

    public set content(v: ViewModel) { this._content = v; } public get content(): ViewModel { return this._content;} private _content: ViewModel;
    public set stableBackground(v: string) { this._stableBackground = v; } public get stableBackground(): string { return this._stableBackground;} private _stableBackground: string;
    public set transitionBackground(v: string) { this._transitionBackground = v; } public get transitionBackground(): string { return this._transitionBackground;} private _transitionBackground: string;
    public set transitioning(v: boolean) { this._transitioning = v; } public get transitioning(): boolean { return this._transitioning;} private _transitioning: boolean;
    public set shallShowAddonDownload(v: boolean) { this._shallShowAddonDownload = v; } public get shallShowAddonDownload(): boolean { return this._shallShowAddonDownload;} private _shallShowAddonDownload: boolean;

}
